import useSWR from "swr";
import { teamClient } from "../clients";
import { useLoggedinUser } from "./useLoggedinUser";

const fetcher = async (_key) => {
  const { data } = await teamClient.getSubscription();
  return data;
}

export const useBilling = () => {
  const { data: user } = useLoggedinUser();
  const { data, error, isValidating, mutate } = useSWR(user?.verified ? '/' : null, fetcher);

  return {
    data,
    error,
    mutate,
    isValidating,
    isLoading: !data && !error && user?.verified,
  }
}
